import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "footer_main" }
const _hoisted_3 = { class: "footer_right" }
const _hoisted_4 = { class: "jump_box" }
const _hoisted_5 = { class: "item_title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"footer_left\" data-v-4abd26ad><div class=\"footer_logo\" data-v-4abd26ad><img src=\"https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741933747160/logo_white.png\" alt=\"\" data-v-4abd26ad></div><div class=\"footer_box\" data-v-4abd26ad><div class=\"item\" data-v-4abd26ad><div data-v-4abd26ad>公司地址</div><div data-v-4abd26ad>成都市金牛区金科南路169号1栋10层1016号</div></div><div class=\"item\" data-v-4abd26ad><div data-v-4abd26ad>联系电话</div><div data-v-4abd26ad>028-61666051</div></div></div><div class=\"footer_record\" data-v-4abd26ad><span data-v-4abd26ad>备案信息</span><a style=\"margin-left:16px;\" href=\"https://beian.miit.gov.cn\" target=\"_blank\" data-v-4abd26ad>蜀ICP备2025128641号-1</a></div><div class=\"footer_record\" data-v-4abd26ad><span data-v-4abd26ad>入网信息</span><span style=\"padding-left:16px;display:flex;align-items:center;\" data-v-4abd26ad><img style=\"width:16px;\" src=\"https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/31/1743391386598/beian.png\" alt=\"\" srcset=\"\" data-v-4abd26ad><a href=\"http://www.beian.gov.cn\" target=\"_blank\" data-v-4abd26ad>川公网安备51010602002812号</a></span></div></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jumpList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "jump_item",
              key: index
            }, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(item.title), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (label, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "item_label",
                  key: idx
                }, [
                  _createVNode(_component_router_link, {
                    to: label.path
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(label.title), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]))
              }), 128))
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}